import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { FormsService } from '@pyg-services/forms/forms.service';
import { FORM_TYPE } from '@pyg-services/forms/forms.constants';
import { FormTypeEnum } from '@pyg-services/forms/forms.types';
import { LangRouterLink } from '@pyg-directives/lang-router-link.directive';

@Component({
  selector: 'app-subscribe',
  templateUrl: './subscribe.component.html',
  styleUrls: ['./subscribe.component.scss'],
  imports: [TranslatePipe, ReactiveFormsModule, LangRouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: FORM_TYPE, useValue: FormTypeEnum.SUBSCRIBE },
    FormsService,
  ],
})
export class SubscribeComponent {
  private readonly formService =
    inject<FormsService<FormTypeEnum.SUBSCRIBE>>(FormsService);

  public readonly subscribeStatus = this.formService.requestStatus;
  public readonly demoForm = this.formService.form;

  readonly place = input.required<string>();

  public sendEmail() {
    this.formService.submit(this.place());
  }

  public resetStatus() {
    this.formService.resetStatus();
  }
}
